import {EventEmitter} from 'eventemitter3'

export const tableLockEvent = new EventEmitter()

export const tableLockEventTypes = {
    TABLE_LOCK_CHANGE: 'TABLE_LOCK_CHANGE',
    TABLE_LOCK_RESTORE_DEFAULT: 'TABLE_LOCK_RESTORE_DEFAULT',
    TABLE_LOCK_DISCARD_COLUMNS: 'TABLE_LOCK_DISCARD_COLUMNS',
    TABLE_LOCK_DISCARD_ROWS: 'TABLE_LOCK_DISCARD_ROWS',

    REF_LOCK_CHANGE_COLUMNS: 'REF_LOCK_CHANGE_COLUMNS',
    REF_LOCK_CHANGE_ROWS: 'REF_LOCK_CHANGE_ROWS',
}

export function getTableLockEventKey(tableType, eventType) {
    if (!tableType) {
        return ''
    }

    switch (eventType) {
        case tableLockEventTypes.TABLE_LOCK_CHANGE:
            return `TABLE_LOCK_CHANGE_${tableType}`

        case tableLockEventTypes.TABLE_LOCK_RESTORE_DEFAULT:
            return `TABLE_LOCK_RESTORE_DEFAULT_${tableType}`

        case tableLockEventTypes.TABLE_LOCK_DISCARD_COLUMNS:
            return `TABLE_LOCK_DISCARD_COLUMNS_${tableType}`

        case tableLockEventTypes.TABLE_LOCK_DISCARD_ROWS:
            return `TABLE_LOCK_DISCARD_ROWS_${tableType}`

        case tableLockEventTypes.REF_LOCK_CHANGE_COLUMNS:
            return `REF_LOCK_CHANGE_COLUMNS_${tableType}`

        case tableLockEventTypes.REF_LOCK_CHANGE_ROWS:
            return `REF_LOCK_CHANGE_ROWS_${tableType}`

        default:
            return ''
    }
}

export function onTableLockChangeListener(
    tableType,
    eventType = tableLockEventTypes.TABLE_LOCK_CHANGE,
    newTableLockConfig = {},
) {
    if (!tableType) {
        return
    }

    tableLockEvent.emit(
        `${getTableLockEventKey(tableType, eventType)}`,
        newTableLockConfig,
    )
}

export function removeTableLockChangeListener(tableType, eventType) {
    if (!tableType) {
        return
    }

    tableLockEvent.removeListener(getTableLockEventKey(tableType, eventType))
}

export function onRefLockChangeListener(
    tableType,
    eventType = tableLockEventTypes.TABLE_LOCK_CHANGE,
    newSelectedItems = [],
) {
    if (!tableType) {
        return
    }

    tableLockEvent.emit(
        `${getTableLockEventKey(tableType, eventType)}`,
        newSelectedItems,
    )
}

export function removeRefLockChangeListener(tableType, eventType) {
    if (!tableType) {
        return
    }

    tableLockEvent.removeListener(getTableLockEventKey(tableType, eventType))
}
